module.exports = __webpack_public_path__ + "static/media/wbs-group-logo.edf1b3c2.png";